import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

const defaultFilter = 50
const defaultFilterStates = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50]

class PageSizeFilter extends PureComponent {
  handleSelectFilter = (e) => {
    const pageSize = parseInt(e.target.value === defaultFilter ? defaultFilter : e.target.value)
    this.props.updateFilter({ pageSize })
  }

  render() {
    const { props, defaultFilter, handleSelectFilter } = this
    return (
      <div className='form-group'>
        <select
          id='pageSize'
          value={props.filter ? props.filter : defaultFilter}
          name='pageSize'
          className='form-control'
          onChange={handleSelectFilter}
        >
          {defaultFilterStates.map((value) => (
            <option key={value} value={value}>{`${value} Records`}</option>
          ))}
        </select>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageSizeFilter))
